// Utility helpers for DashboardKVS

export const asObject = payload =>
  payload && typeof payload === 'object' && !Array.isArray(payload)
    ? payload
    : {};

export const formatDateInput = value => {
  if (!value) return '';
  const str = String(value);
  if (str.length !== 8) return '';
  const year = str.slice(0, 4);
  const month = str.slice(4, 6);
  const day = str.slice(6, 8);
  return `${year}-${month}-${day}`;
};

export const isIsoDate = value => /^\d{4}-\d{2}-\d{2}$/.test(value);

export const parseDateInput = value => {
  if (!value) return null;
  const numeric = Number(String(value).replace(/-/g, ''));
  return Number.isNaN(numeric) ? null : numeric;
};

export const toDateKey = value => {
  if (value === null || typeof value === 'undefined') return '';
  if (typeof value === 'string') {
    if (isIsoDate(value)) return value;
    if (value.length === 8 && Number(value)) {
      const iso = formatDateInput(value);
      if (iso) return iso;
    }
    return value;
  }
  const iso = formatDateInput(value);
  if (iso) return iso;
  return String(value);
};

export const parseDateKeyToNumeric = value => {
  if (!value) return null;
  if (isIsoDate(value)) return parseDateInput(value);
  const numeric = Number(String(value).replace(/-/g, ''));
  return Number.isNaN(numeric) ? null : numeric;
};

export const todayIso = () => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const normalizeOptions = options =>
  options.map(option => ({
    value: String(option.value),
    label: option.label,
    description: option.label
  }));
